import React from 'react'
import { KatDropdown, KatInputGroup, KatLabel } from '@amzn/katal-react';
import { getRequiredLabel, handleError } from './widgetUtil';
import { WidgetProps } from 'react-jsonschema-form';
import * as constants from '../../appConstants';

class SelectWidget extends React.Component<WidgetProps> {

    handleChange = (evt: any, onChange: Function) => {
        evt.preventDefault();
        onChange(evt.target.value);
    };

    updatedOptions = (options: any) => {
        let result: any = [];
        options.enumOptions.map((op: any) => {
            const { label, value } = op;
            result.push({ 'name': label, 'value': value});
          });
        return result;
    };

    dropdown() {
        let {state, stateEmphasis, stateLabel} = handleError(this.props.rawErrors);
        let newOps = this.updatedOptions(this.props.options);
        return (
            <KatDropdown
                value={this.props.value}
                disabled={this.props.disabled}
                options={newOps}
                onChange={(evt: any) => this.handleChange(evt, this.props.onChange)}
                state={state}
                stateEmphasis={stateEmphasis}
                stateLabel={stateLabel}
            />
        );
    }

    render() {
        if (this.props.label === undefined) {
            return this.dropdown();
        } else {
            return (
                <div>
                    <KatInputGroup>
                        <KatLabel
                            className={constants.CUSTOM}
                            text={getRequiredLabel(this.props.required, this.props.label)}
                            tooltip-text={constants.ToolTip[this.props.label]}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        {this.dropdown()}
                    </KatInputGroup>
                </div>
            );
        }
    }

}

export default SelectWidget;
